import React from 'react'

const SvgCalendarWithDropOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M17.211 12.058a.413.413 0 00-.543.112c-.196.293-.423.6-.694.964C14.78 14.755 13 17.2 13 18.598c0 1.02.453 1.942 1.177 2.613A4.202 4.202 0 0017 22.287c1.102 0 2.098-.42 2.823-1.09.724-.671 1.177-1.593 1.177-2.613 0-1.398-1.781-3.829-2.974-5.45-.256-.35-.483-.67-.694-.964a.443.443 0 00-.12-.112z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 4H5c-1.333 0-2 .668-2 2.004V20c0 1.333.667 2 2 2h8.062a5.748 5.748 0 01-.913-2H5V10h11.717l.115-.157c.442-.59.81-1.09 1.128-1.567a.67.67 0 01.883-.181.731.731 0 01.157.132V6c0-1.333-.667-2-2-2h-1V2.941C16 2.314 15.667 2 15 2s-1 .314-1 .941V4H8.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1zM5 8V6h12v2H5z'
    />
    <path d='M14.92 12.514C14.784 12.17 14.478 12 14 12h-.998c-.667-.001-1.002.332-1.002 1 0 .668.333 1.001 1 1h.946c.31-.498.64-.997.974-1.486zM7 13c0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998C7.335 11.999 7 12.332 7 13zM7 17c0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998C7.335 15.999 7 16.332 7 17zM16 8h3v1a1 1 0 01-1 1h-2V8z' />
  </svg>
)

export default SvgCalendarWithDropOutline
